
import { Lookup, AccessCardType, User } from '@app/core';
import { LookupAction, LookupActionTypes } from '../actions';

export interface State {
  licenseTypesLookup: Lookup[];
  contactTypesLookup: Lookup[];
  countriesLookup: Lookup[];
  idTypesLookup: Lookup[];
  accessCardTypesLookup: AccessCardType[];
  requestAccessCardResonsLookup: Lookup[];
  venueTypesLookup: Lookup[];
  chargeTypesLookup: Lookup[];
  users: User[];
  accessCardCancellationReasonLookup: Lookup[];
  requestStatusLookup: Lookup[];
}

export const initialState: State = {
  licenseTypesLookup: [],
  contactTypesLookup: [],
  countriesLookup: [],
  idTypesLookup: [],
  venueTypesLookup: [],
  accessCardTypesLookup: null,
  requestAccessCardResonsLookup: null,
  chargeTypesLookup: [],
  users: null,
  accessCardCancellationReasonLookup: null,
  requestStatusLookup : [],
};

export function reducer(state = initialState, action: LookupAction): State {
  switch (action.type) {
    case (LookupActionTypes.LoadLicenseTypesSuccess): {
      return {
        ...state,
        licenseTypesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadContactTypesSuccess): {
      return {
        ...state,
        contactTypesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadCountriesSuccess): {
      return {
        ...state,
        countriesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadIDTypesSuccess): {
      return {
        ...state,
        idTypesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadVenueTypesSuccess): {
      return {
        ...state,
        venueTypesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadAccessCardTypesSuccess): {
      return {
        ...state,
        accessCardTypesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadRequestAccessCardReasonsSuccess): {
      return {
        ...state,
        requestAccessCardResonsLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadChargeTypesSuccess): {
      return {
        ...state,
        chargeTypesLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadUsers): {
      return {
        ...state,
        users: null
      }
    }
    case (LookupActionTypes.LoadUsersSuccess): {
      return {
        ...state,
        users: action.payload
      }
    }

    case (LookupActionTypes.LoadAccessCardCancellationReasonSuccess): {
      return {
        ...state,
        accessCardCancellationReasonLookup: action.payload
      }
    }

    case (LookupActionTypes.LoadRequestStatusSuccess): {
      return {
        ...state,
        requestStatusLookup: action.payload
      }
    }
  }
  return state;
}

export const getLicenseTypes = (state: State) => state.licenseTypesLookup;
export const getContactTypes = (state: State) => state.contactTypesLookup;
export const getCountries = (state: State) => state.countriesLookup;
export const getIdTypes = (state: State) => state.idTypesLookup;
export const getVenueTypes = (state: State) => state.venueTypesLookup;
export const getAccessCardTypes = (state: State) => state.accessCardTypesLookup;
export const getRequestAccessCardReasonsSuccess = (state: State) => state.requestAccessCardResonsLookup;
export const getChargeTypes = (state: State) => state.chargeTypesLookup;
export const getUsers = (state: State) => state.users;
export const getAccessCardCancellationReasons = (state: State) => state.accessCardCancellationReasonLookup;
export const getRequestStatuses = (state: State) => state.requestStatusLookup;



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/lookup.reducers.ts